import prestashop from 'prestashop';


function initFooterYoutubeVideo() {
    // include youtube only on homepage


    if ($('body').hasClass('page-index')) {


        var url = $('#youtube-homepage').text().trim();
        var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var match = url.match(regExp);
        if (match && match[2].length == 11) {

            console.log('match, create tag');
            var tag = document.createElement('script');

            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            console.log(firstScriptTag);
            console.log(tag);
            var player;


            function onYouTubeIframeAPIReady() {
                console.log('onYouTubeIframeAPIReady');
                player = new YT.Player('homevideo', {
                    height: '414',
                    width: '100%',
                    videoId: match[2], // youtube video id
                    playerVars: {
                        'autoplay': 1,
                        'rel': 0,
                        'showinfo': 0,
                        'suggestedQuality': 'large'
                    },
                    events: {
                        'onStateChange': onPlayerStateChange
                    }
                });
                player.playVideo();
            }

            function onPlayerStateChange(event) {
                if (event.data == YT.PlayerState.ENDED) {
                    $('#stock-play-btn').fadeIn('normal');
                }
            }

            $(document).on('click', '#stock-play-btn', function () {
                $('#stock-play-btn').fadeOut('fast');
                onYouTubeIframeAPIReady()
            });
        }
    }
}

function initMobileMenu() {

}

var stylespluginmap = [{
    "elementType": "geometry",
    "stylers": [{
        "color": "#f5f5f5"
    }]
},
    {
        "elementType": "labels.icon",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#616161"
        }]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [{
            "color": "#f5f5f5"
        }]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#bdbdbd"
        }]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [{
            "color": "#eeeeee"
        }]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#757575"
        }]
    },
    {
        "featureType": "poi.business",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [{
            "color": "#e5e5e5"
        }]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#9e9e9e"
        }]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [{
            "color": "#ffffff"
        }]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#757575"
        }]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [{
            "color": "#dadada"
        }]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#616161"
        }]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#9e9e9e"
        }]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [{
            "color": "#e5e5e5"
        }]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [{
            "color": "#eeeeee"
        }]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{
            "color": "#c9c9c9"
        }]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#9e9e9e"
        }]
    }
];

function initGoogleMaps() {
    var mapKey = 'distributorsMap';
    var contactMap = googleMapsRepository.getMap(mapKey);
    var markers = [];

    function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition);
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }

    function showPosition(position) {
        var $index = '666';
        var $lat = position.coords.latitude;
        var $lon = position.coords.longitude;
        if ($lat != '' && $lon != '') {
            var markerOptions = {
                animation: google.maps.Animation.BOUNCE,
                icon: 'themes/classic-rocket/assets/img/gmaps.png',
                visible: true,
                position: new google.maps.LatLng(Number($lat), Number($lon)),
                title: 'tu jesteś'
            }
            var marker = googleMapsRepository.setMarker(mapKey, markerOptions);
            var infowindow = new google.maps.InfoWindow({
                content: 'TWOJA LOKALIZACJA'
            });
            infowindow.open(contactMap, marker);
            google.maps.event.addListener(marker, 'click', function () {
                if (infowindow['anchor']) {
                    infowindow.close(contactMap, marker);
                } else {
                    infowindow.open(contactMap, marker);
                }
            });
            markers[$index] = marker;
        }
    }

    function addDistributor(googleMapsRepository, mapKey, contactMap) {
        $('.dystrybutor').each(function (pos, value) {
            var $$ = $(value);
            var $index = $$.attr('dystrid');
            var $lat = $$.attr('dystrlat');
            var $lon = $$.attr('dystrlon');
            if ($lat != '' && $lon != '') {
                var markerOptions = {
                    //animation: google.maps.Animation.DROP,
                    icon: 'themes/classic-rocket/assets/img/gmaps_dys.png',
                    visible: true,
                    position: new google.maps.LatLng(Number($lat), Number($lon)),
                    title: ($$.find('.dystrybutor-nazwa')).html()
                }
                var marker = googleMapsRepository.setMarker(mapKey, markerOptions);
                var contentString = '<div id="content">' +
                    '<div id="siteNotice">' +
                    '<p>' + ($$.find('.dystrybutor-nazwa')).html() + '</p>' +
                    '<p>' + ($$.find('.dystrybutor-dane')).html() + '</p>' +
                    '</div>';
                var infowindow = new google.maps.InfoWindow({
                    content: contentString
                });
                google.maps.event.addListener(marker, 'click', function () {
                    if (infowindow['anchor']) {
                        infowindow.close(contactMap, marker);
                    } else {
                        infowindow.open(contactMap, marker);
                    }
                });
                markers[$index] = marker;
            }
        });
    }

    if (!contactMap) {

        var mapOptions = {
            //center: new google.maps.LatLng(Number(50.054886),Number(19.954463)),
            center: new google.maps.LatLng(52.091546, 19.985771),
            zoom: (($(window).width() > 767) ? 6 : 5),
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            zoomControl: true,
            panControl: false,
            overviewMapControl: false,
            styles: stylespluginmap
        }

        googleMapsRepository.initializeMap(mapKey, $('#map-canvas')[0], mapOptions);

        function openmarker() {
            var $$ = $(this);
            var $nr = $$.attr('dystrid');
            // markers[$nr].setVisible(!$$.hasClass('active'));
            if (!$$.hasClass('active')) {
                markers[$nr].setIcon('themes/classic-rocket/assets/img/gmaps.png');
            } else {
                markers[$nr].setIcon('themes/classic-rocket/assets/img/gmaps_dys.png');
            }
            $$.toggleClass('active');
        }

        $('body').on('click', '.dystrybutor', openmarker);
        getLocation();
        $('body').ready(function () {
            console.log('body ready');
            addDistributor(googleMapsRepository, mapKey, contactMap);
        });
    }

};


function initContactMap() {

    console.log('initialize contact map');
    var mapKey = 'contactMap';
    var contactMap = googleMapsRepository.getMap(mapKey);

    if (!contactMap) {

        var mapOptions = {

            center: new google.maps.LatLng(50.0564000, 19.9522744),
            zoom: (($(window).width() > 767) ? 16 : 15),
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            zoomControl: true,
            panControl: false,
            overviewMapControl: false,
            styles: stylespluginmap
        }
        googleMapsRepository.initializeMap(mapKey, $('#contact-map')[0], mapOptions);

        var markerOptions = {
            //animation: google.maps.Animation.BOUNCE,
            icon: 'themes/classic-rocket/assets/img/gmaps.png',
            visible: true,
            position: new google.maps.LatLng(50.0548897, 19.9522744),

        }
        var marker = googleMapsRepository.setMarker(mapKey, markerOptions);
    }
};


$(document).ready(function () {
    console.log($.cookie('cookies'));
    if (undefined == $.cookie('cookies')) {
        $('#cookies').css('display', 'flex');
    }

});
$('.cookies-button').click(function () {
    $.cookie(
        'cookies',
        'ok', {
            expires: 365,
            path: '/'
        }
    );
    $('#cookies').hide();
});


function initGridView() {
    $('.icon__list').click(function () {
        document.cookie = "show_list=true; expires=Thu, 30 Jan 2100 12:00:00 UTC; path=/";
        $('#js-product-list .product-miniature').addClass('product_show_list');
    });

    $('.icon__grid').click(function () {
        document.cookie = "show_list=; expires=Thu, 30 Jan 1970 12:00:00 UTC; path=/";
        $('#js-product-list .product-miniature').removeClass('product_show_list');
    });

    prestashop.on('updateProductList', function (event) {
        $('.show_list').click(function () {
            $('#js-product-list .product-miniature').addClass('product_show_list');
        });

        $('.icon__grid').click(function () {
            $('#js-product-list .product-miniature').removeClass('product_show_list');
        });
    });
}

function sortSelectOptions($element) {
    var options = $element.find('option');
    options.sort(function (a, b) {
        if (a.text.toUpperCase() > b.text.toUpperCase()) return 1;
        else if (a.text.toUpperCase() < b.text.toUpperCase()) return -1;
        else return 0;
    });

    $element.empty().append(options);
}


function sortSelectAlphabetically() {
    if ($('.custom-select').length) {
        $('.custom-select').each(function (index) {
            sortSelectOptions($(this));
        });
        prestashop.on('updatedProduct', function (event) {
            console.log('update product event and custom select sort');
            $('.custom-select').each(function (index) {
                sortSelectOptions($(this));
            });
        });

    }
}

function customQuantityInputs() {
    const quantityInputs = document.querySelectorAll('.quantity-input');

    quantityInputs.forEach(wrapper => {
        const input = wrapper.querySelector('.quantity');
        const minusBtn = wrapper.querySelector('.minus-btn');
        const plusBtn = wrapper.querySelector('.plus-btn');

        plusBtn.addEventListener('click', () => {
            input.stepUp();
        });

        minusBtn.addEventListener('click', () => {
            input.stepDown();
        });
    });
}

function blogHomeCarousel() {
    $('#news_home').slick({
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

function moveMegaMenu() {
    const megaMenu = document.querySelector('.ets_mm_megamenu');
    const target = document.querySelector('.header-top');

    if (!megaMenu || !target) return;

    if (window.innerWidth < 768) {
        if (!target.contains(megaMenu)) {
            target.appendChild(megaMenu);
        }
    } else {
        const originalTarget = document.querySelector('#header');
        if (originalTarget && !originalTarget.contains(megaMenu)) {
            originalTarget.appendChild(megaMenu);
        }
    }
}

$(document).ready(function () {
    initFooterYoutubeVideo();
    initGridView();
    sortSelectAlphabetically();
    customQuantityInputs();
    moveMegaMenu();

    if ($('#contact-map').length) {
        initContactMap();
    }
    if ($('#map-canvas').length) {
        initGoogleMaps();
    }
    if ($('#news_home').length) {
        blogHomeCarousel();
    }


    window.addEventListener('resize', moveMegaMenu);

});

